import React from 'react'
import hipladeTemplate from '../../common/template'
import Event from '../components/Event'

function EventDashboard() {
  return <Event />
}

export default hipladeTemplate(EventDashboard)
